import React from "react";
import {ColumnsType} from "antd/es/table";
import {
  FIELD_TYPE,
  FORMAT_TIME,
  TT_PHIEU_KHO,
  TT_PHIEU_VTYT,
} from "types/enums";
import {ColumnProps} from "types/models";
import {formatDateToString, formatToCurrencyType} from "helper/common";
import {listNguonVTYT, listTTPhieuVTYT} from "data/list";
import moment from "moment";
import {Tooltip, Typography} from "antd";

const {INPUT, SELECT, AUTO_COMPLETE, COMBO_BOX} = FIELD_TYPE;
const inputFields: any[] = [
  {
    type: COMBO_BOX,
    name: "khoId",
    label: "Kho",
  },
  // {
  //   type: COMBO_BOX,
  //   name: "nguonVTYTId",
  //   label: "Nguồn VTYT",
  // },
  {
    type: AUTO_COMPLETE,
    name: "tenThuoc",
    label: "Tên thuốc",
  },
];
const allColumns: ColumnProps[] = [
  {
    key: "index",
    title: "STT",
    show: true,
    dataIndex: "index",
    render(value, record, index) {
      return <>{index + 1}</>;
    },
    width: 50,
    align: "center",
  },
  {
    key: "thuocId",
    title: "Mã thuốc",
    align: "center",
    show: true,
    dataIndex: "thuocId",
  },
  {
    title: "Tên thuốc",
    key: "tenThuoc",
    show: true,
    dataIndex: "tenThuoc",
  },
  {
    title: "SL đã xuất",
    key: "soLuongDaXuat",
    show: true,
    dataIndex: "soLuongDaXuat",
    align: "center",
  },
  {
    title: "SL hết hạn",
    key: "soLuongHetHanTong",
    show: true,
    dataIndex: "soLuongHetHanTong",
    align: "center",
  },
  {
    title: "SL nhập",
    key: "soLuongNhap",
    show: true,
    dataIndex: "soLuongNhap",
    align: "center",
  },
  {
    title: "SL tồn",
    key: "soLuongTonTong",
    show: true,
    dataIndex: "soLuongTonTong",
    align: "center",
  },
  {
    title: "Ghi chú",
    key: "ghiChu",
    show: true,
    dataIndex: "ghiChu",
    align: "left",
    render: text => (
      <Tooltip title={text} placement="top" arrow={false}>
        <Typography.Text ellipsis={true}>{text}</Typography.Text>
      </Tooltip>
    ),
  },
];

export {allColumns, inputFields};
